var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg023Can(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 32 56",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "040---Can",
    fill: "rgb(0,0,0)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m31 3c0-.871-5.257-3-15-3s-15 2.129-15 3 5.257 3 15 3 15-2.129 15-3zm-10-1h2c.5522847 0 1 .44771525 1 1s-.4477153 1-1 1h-2c-.5522847 0-1-.44771525-1-1s.4477153-1 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m2.712 52.278c1.488 2.004 5.488 3.722 13.288 3.722 7.768 0 11.768-1.7 13.271-3.717-4.3104937 1.2444463-8.7857274 1.8234514-13.271 1.717-4.4912331.1070348-8.97240769-.4736834-13.288-1.722z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m13 35c-6.582 0-10.654 1.52-13 2.908v10.092c0 .667.934 1.278 1.49 1.583.03819054.0208476.07493969.0442334.11.07 2.725 1.447 8.22 2.347 14.4 2.347s11.678-.9 14.4-2.348c.0345415-.0252068.0706105-.0482509.108-.069.556-.3 1.49-.916 1.49-1.583v-3.777c-4.519-.091-6.8-2.352-9-4.557-2.389-2.4-4.647-4.666-9.998-4.666z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m29.7 6.13c-3.749 1.421-9.848 1.87-13.7 1.87s-9.951-.449-13.7-1.87c-1.474 1.17-2.3 2.27-2.3 5.87v4.348c3.1-1.801 9.2-4.348 19-4.348 6.571 0 10.574 1.883 13 3.969v-3.969c0-3.6-.826-4.7-2.3-5.87z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m19 14c-10.635 0-16.6 3.087-19 4.7v16.93c2.668-1.344 6.829-2.63 13-2.63s8.963 2.791 11.418 5.253c2.072 2.08 3.874 3.885 7.582 3.978v-23.409c-1.83-2.259-5.546-4.822-13-4.822z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg023Can);
export default __webpack_public_path__ + "static/media/023-can.56c06dd1c1573c93f21859c355d75b37.svg";
export { ForwardRef as ReactComponent };